import FeaturedDestinations from './FeaturedDestinations';

export default FeaturedDestinations;
